import { render, staticRenderFns } from "./QuestionComponent.vue?vue&type=template&id=fd516e6c&"
import script from "./QuestionComponent.vue?vue&type=script&lang=js&"
export * from "./QuestionComponent.vue?vue&type=script&lang=js&"
import style0 from "./QuestionComponent.vue?vue&type=style&index=0&id=fd516e6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports